// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-1dW5N";
var _4 = "root_withUpgrade-1fsCg";
var _5 = "icon-3Res_";
var _6 = "add-3iLt5";
var _7 = "item-3Xr0B";
var _8 = "deleteButton-1Ikyb";
var _9 = "baggage_count-3OfcK";
var _a = "baggage_direction-w0oHU";
var _b = "price-3MTmx";
var _c = "counts-2njwl";
var _d = "count-q2SyA";
var _e = "footer-2cqBZ";
var _f = "footer_empty-1J83s";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "root_withUpgrade", _5 as "icon", _6 as "add", _7 as "item", _8 as "deleteButton", _9 as "baggage_count", _a as "baggage_direction", _b as "price", _c as "counts", _d as "count", _e as "footer", _f as "footer_empty" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "root_withUpgrade": _4, "icon": _5, "add": _6, "item": _7, "deleteButton": _8, "baggage_count": _9, "baggage_direction": _a, "price": _b, "counts": _c, "count": _d, "footer": _e, "footer_empty": _f }
